import { ReactNode } from "react";

export interface IMenuItems {
  name: string;
  value?: ReactNode;
  logo?: string;
  disabled?: boolean;
  isActive?: boolean;
  activeColor?: string;
  toolTip?: string;
  coverage?: string | number | null;
}

export enum EMenuItems {
    GREEN = 'GREEN',
    VALUE = 'VALUE',
    DCF = 'DCF',
    KPIS = 'KPIS',
    DOWNLOAD = 'DOWNLOAD',
  }
